import React from 'react';
import Loader from './Loader';

/**
 * Reusable LoadingOverlay
 * Standardizes the "minimal blurred loader" experience.
 * Even if message/subtext are passed, they are hidden to maintain the "dont show anything" requested style.
 */
const LoadingOverlay = () => {
  return <Loader />;
};

export default LoadingOverlay;
